import { authFetch } from './api';

export const MIN_PAYOUT_AMOUNT = 5000;

const readError = async (response, fallback) => {
  try {
    const data = await response.json();
    return data?.message || fallback;
  } catch {
    return fallback;
  }
};

export const getPayouts = async () => {
  const response = await authFetch('/api/artists/payouts');
  if (!response.ok) {
    throw new Error(await readError(response, 'Impossible de charger les retraits.'));
  }
  return response.json();
};

export const requestPayout = async (amount) => {
  const response = await authFetch('/api/artists/payouts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount: Math.floor(Number(amount)) })
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.message || 'Impossible d’envoyer la demande de retrait.');
  }
  return data;
};
